import { useI18n } from '../../../shared/i18n/I18nProvider';
import { ReadOnlyModal } from '../../../shared/ui/WorkspaceKit';

export function NewAppointmentModal({ onClose }: { onClose: () => void }) {
  const { t } = useI18n();
  return <ReadOnlyModal feature={t('Tạo lịch hẹn')} onClose={onClose} />;
}
